module.exports = __webpack_public_path__ + "d308073b/img/at-icon.5d6fc5d8.svg";